export function getComments(postName, offset, number) {
  if (process.env.NODE_ENV === 'development') {
    return import('../../mock/comments').then((module) => {
      return module.mockData().comments;
    });
  }

  const wpnonce = window?.dataWP?.config?.wpnonce;

  const wpNonceParam = wpnonce ? `&_wpnonce=${wpnonce}` : '';

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_comments?post_name=${postName}&offset=${offset}&number=${number}${wpNonceParam}`,
    {
      method: 'GET',
    }
  )
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      if (!res.success) {
        throw Error(res.data.message);
      }

      return res.comments;
    });
}
